import React, { useEffect, useState } from "react";
import "../styles.css";

type CoachMarkStepThreeProps = {
  visible: boolean;
  onNext: () => void;
  targetSelector?: string;
};

const MAX_CARD_WIDTH = 430;

const CoachMarkStepThree = ({
  visible,
  onNext,
  targetSelector = ".home-frag-cont",
}: CoachMarkStepThreeProps) => {
  const [position, setPosition] = useState({ top: 250, left: 12 });

  useEffect(() => {
    if (!visible) return;

    const updatePosition = () => {
      const target = document.querySelector(targetSelector) as HTMLElement | null;

      if (!target) {
        setPosition({ top: 250, left: 12 });
        return;
      }

      const rect = target.getBoundingClientRect();
      const effectiveCardWidth = Math.min(MAX_CARD_WIDTH, window.innerWidth - 24);
      const desiredTop = rect.bottom + 12;
      const maxTop = Math.max(12, window.innerHeight - 196);
      const desiredLeft = rect.left - 8;
      const maxLeft = Math.max(12, window.innerWidth - effectiveCardWidth - 12);

      setPosition({
        top: Math.max(12, Math.min(desiredTop, maxTop)),
        left: Math.max(12, Math.min(desiredLeft, maxLeft)),
      });
    };

    updatePosition();
    window.addEventListener("resize", updatePosition);
    window.addEventListener("scroll", updatePosition, true);

    return () => {
      window.removeEventListener("resize", updatePosition);
      window.removeEventListener("scroll", updatePosition, true);
    };
  }, [targetSelector, visible]);

  if (!visible) return null;

  return (
    <div
      className="coachmark-overlay"
      role="dialog"
      aria-modal="true"
      aria-label="Coach mark step three"
    >
      <div
        className="coachmark-step-three-card"
        style={{ top: `${position.top - 20}px`, left: `${position.left + 8}px` }}
      >
        <div className="coachmark-step-three-content">
          <img
            src={require("../../assets/coachViewBlackLogo.png")}
            alt=""
            aria-hidden="true"
            className="coachmark-step-three-logo"
          />
          <div className="coachmark-step-three-text-wrap">
            <div className="coachmark-step-three-text">Complete fun daily</div>
            <div className="coachmark-step-three-text">challenges to grow</div>
            <div className="coachmark-step-three-text">
              and earn <span className="coachmark-step-three-points">points!</span>
            </div>
          </div>
        </div>

        <button
          type="button"
          onClick={onNext}
          className="coachmark-step-three-next"
          aria-label="Finish coach mark"
        >
          <img
              src={require("../../assets/pink-left-arrow.png")}
              alt=""
              aria-hidden="true"
              className=""
            />
        </button>
      </div>
    </div>
  );
};

export default CoachMarkStepThree;
